<div
  class="floating-chat-container"
  [class.mobile]="isMobile"
  *ngIf="isUserLoggedIn"
>
  <div
    class="service-unavailable-tooltip"
    *ngIf="isServiceUnavailableTooltipVisible"
  >
    {{ getServiceTooltipMessage() }}
  </div>

  <button
    #floatingButton
    class="floating-chat-button"
    [class.hidden]="isChatOpen"
    [class.has-unread]="hasUnreadMessages"
    [class.offline]="!isOnline"
    [class.thinking]="isThinking"
    [class.unavailable]="!isOnline || !isUserLoggedIn"
    (click)="openChat()"
    (touchstart)="$event.stopPropagation()"
    [attr.aria-label]="getAriaLabel()"
    [attr.title]="getButtonTitle()"
    tabindex="0"
  >
    <div class="button-icon-container">
      <svg
        class="button-icon chat-icon"
        [class.visible]="!isThinking"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
        ></path>
        <path d="M8 10h8"></path>
        <path d="M8 14h6"></path>
      </svg>

      <div class="thinking-animation" [class.visible]="isThinking">
        <div class="thinking-dot"></div>
        <div class="thinking-dot"></div>
        <div class="thinking-dot"></div>
      </div>
    </div>

    <div
      class="status-indicator"
      [class.online]="isOnline && isUserLoggedIn"
      [class.offline]="!isOnline || !isUserLoggedIn"
    ></div>

    <div
      class="unread-badge"
      [class.visible]="hasUnreadMessages && isUserLoggedIn"
    >
      <span>!</span>
    </div>

    <div class="pulse-effect" [class.active]="isOnline && isUserLoggedIn"></div>
  </button>
</div>

<div
  class="mobile-backdrop"
  [class.visible]="isChatOpen && isMobile && isUserLoggedIn"
  (click)="handleChatClose()"
  (touchstart)="$event.stopPropagation()"
></div>

<div
  #chatContainer
  class="chat-container"
  [class.visible]="isChatOpen"
  [class.minimized]="isMinimized"
  [class.mobile]="isMobile"
  (touchstart)="$event.stopPropagation()"
>
  <app-chat-interface
    #chatInterface
    [isVisible]="isChatOpen"
    (onClose)="closeChat()"
  ></app-chat-interface>
</div>
